import { EXTRALARGE } from 'shared/variables';
import { Heading3 } from 'components/Heading3';
import { IconMail, IconPhone, IconWhatsapp } from 'components/Icons';
import { Link } from 'components/Link';
import { MaxWidth } from 'components/MaxWidth';
import styles from './Contact.module.css';

export const Contact = ({
  email = '',
  subtext = 'Bereikbaar: maandag, dinsdag en donderdag van 9.00-15.00 uur.',
  tel = '',
  title,
  whatsapp = '',
}) => {
  const items = [
    { icon: 'mail', url: `mailto:${email}`, label: email },
    {
      icon: 'tel',
      url: `tel:${tel}`,
      label: (tel || '').replace(/(\d{2})(\d{3})(\d{3})(\d{2})/, '$1 $2 $3 $4'),
    },
    {
      icon: 'whapp',
      url: `https://wa.me/${whatsapp}`,
      label: 'Whatsapp',
    },
  ].filter((item) => !(item.label === 'Whatsapp' && !whatsapp));

  return (
    <div className={styles.container}>
      <MaxWidth size={EXTRALARGE}>
        <Heading3 as="h2">{title}</Heading3>
        <div className={styles.itemsContainer}>
          {items.map((item) => (
            <ContactItem key={item.url} {...item} />
          ))}
        </div>
        {subtext && <div className={styles.subtext}>{subtext}</div>}
      </MaxWidth>
    </div>
  );
};

const ContactItem = ({ icon, url, label }) => {
  const icons = {
    mail: IconMail,
    tel: IconPhone,
    whapp: IconWhatsapp,
  };

  const Icon = icons[icon] || IconMail;

  return (
    <div className={styles.item}>
      <div className={styles.itemIconContainer}>
        <Icon />
      </div>
      <Link className={styles.itemLink} url={url}>
        {label}
      </Link>
    </div>
  );
};
